var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLine',{ref:"chartInstance",staticStyle:{"height":"30vh"},attrs:{"chartData":_vm.chartData,"chartOptions":_vm.chartOptions,"plugins":_vm.chartPlugins}})
}
var staticRenderFns = []

export { render, staticRenderFns }